"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddressApiBasePath = exports.AddressApiProvider = exports.AddressApiContext = void 0;
var react_1 = __importStar(require("react"));
exports.AddressApiContext = react_1.createContext({ basePath: '' });
/**
 * Add this provider to _app to enable the use of all of the hooks.
 */
function AddressApiProvider(props) {
    var basePath = props.basePath, children = props.children;
    return react_1.default.createElement(exports.AddressApiContext.Provider, { value: { basePath: basePath } }, children);
}
exports.AddressApiProvider = AddressApiProvider;
function useAddressApiBasePath() {
    var basePath = react_1.useContext(exports.AddressApiContext).basePath;
    return basePath;
}
exports.useAddressApiBasePath = useAddressApiBasePath;
